@if (rawSVG) {
  <span [class]="classList" [innerHTML]="rawSVG"></span>
} @else {
  <svg-icon [src]="ppSrc" [class]="classList" [svgStyle]="svgStyle"></svg-icon>
}
